// extracted by mini-css-extract-plugin
export default {"container":"Header_container__Bdw3O","logo":"Header_logo__jynaO","email":"Header_email__SS-IO","mobileEmail":"Header_mobileEmail__PskQ-"};